/* eslint-disable parog-web/no-glint-expect-error-directive */
import { hash } from '@ember/helper';
import Component from '@glimmer/component';
import type { Signature as S2 } from 'parog-web/components/fui-calendar';
import FuiCalendar from 'parog-web/components/fui-calendar';
import { dateFormat } from 'parog-web/helpers/datepicker-format';

interface Formatter {
  date: (date: Date) => string;
}

export interface S {
  Element: S2['Element'];
  Args: {
    labelName?: string;
    propertyName?: string;
    isMandatory?: boolean;
    formatter?: Formatter;
    onChange: S2['Args']['onFocusOut'];
  } & Pick<S2['Args'], 'selected' | 'disabled' | 'isReadOnly'>;
}

export default class DatePickerComponent extends Component<S> {
  get effectiveFormatter() {
    // Use default formatter if @formatter is not provided
    return this.args.formatter ?? this.#formatter;
  }

  // défault formatter
  #formatter: Formatter = {
    date: dateFormat
  };

  <template>
    {{#if @labelName}}
      <label>
        {{@labelName}}{{if @isMandatory ' *'}}
      </label>
    {{/if}}
    <FuiCalendar
      @selected={{@selected}}
      {{! @glint-expect-error }}
      @settings={{hash type='date' formatter=this.effectiveFormatter}}
      @disabled={{@disabled}}
      @onFocusOut={{@onChange}}
      @isReadOnly={{@isReadOnly}}
      data-test-input={{@propertyName}}
      ...attributes
    />
  </template>
}
